import {Button, Divider, Form, Input, message} from "antd";
import React from "react";
import {ChooseAdditions} from "../../../../../filters/crm/ChooseAdditions";
import {ChooseUnderstanding} from "../../../../../filters/crm/ChooseUnderstanding";
import {ChooseExclusion} from "../../../../../filters/crm/ChooseExclusion";
import {ChooseNotes} from "../../../../../filters/crm/ChooseNotes";
import {SettingsPost} from "../../../../../models/crm/settings";
import {ProposalUpdate} from "../../../../../models/crm/proposal";
import {ChoosePaymentTerm} from "../../../../../filters/crm/ChoosePaymentTerm";

const FormItem = Form.Item;
const {TextArea} = Input;

class AddSettingsForm extends React.Component {
    state = {
        loading: false,
    };
    submitProposalSettingForm = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const proposal = this.props.proposal.id;
                values['proposal'] = proposal;
                SettingsPost(values)
                    .then(response => {
                        ProposalUpdate(proposal, {'active': true})
                            .then(() => {
                                this.props.onComplete();
                            })
                    })
            }
        })
    };

    handleAdditionsChange = (value) => {
        this.props.form.setFieldsValue({
            additions: value,
        });
    };
    handleUnderstandingChange = (value) => {
        this.props.form.setFieldsValue({
            understanding: value,
        });
    };
    handleExclusionChange = (value) => {
        this.props.form.setFieldsValue({
            exclusion: value,
        });
    };
    handleNotesChange = (value) => {
        this.props.form.setFieldsValue({
            notes: value,
        });
    };
    handlePaymentChange = value => {
        this.props.form.setFieldsValue({
            payment_term: value,
        });
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const {loading} = this.state;
        return (
            <React.Fragment>
                <div className="row m-0 add-settings">
                    <div className="col-sm-4 col-12">
                        <div className="floating-label">
                            <FormItem label="Choose Additions">
                                <ChooseAdditions onChange={this.handleAdditionsChange}/>
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-1">
                        <div className="floating-label job-divider">
                            <Divider>or</Divider>
                        </div>
                    </div>
                    <div className="col-sm-7 col-12">
                        <div className="floating-label">
                            <FormItem label="Enter Custom Additions">
                                {getFieldDecorator('additions', {
                                })(<TextArea className="job-desc-field" autosize={{minRows: 1, maxRows: 8}}
                                             placeholder="Enter Here"/>)}
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-4 col-12">
                        <div className="floating-label">
                            <FormItem label="Choose Understanding">
                                <ChooseUnderstanding onChange={this.handleUnderstandingChange}/>
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-1">
                        <div className="floating-label job-divider">
                            <Divider>or</Divider>
                        </div>
                    </div>
                    <div className="col-sm-7 col-12">
                        <div className="floating-label">
                            <FormItem label="Enter Custom Understanding">
                                {getFieldDecorator('understanding', {
                                })(<TextArea className="job-desc-field" autosize={{minRows: 1, maxRows: 8}}
                                             placeholder="Enter Here"/>)}
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-4 col-12">
                        <div className="floating-label">
                            <FormItem label="Choose Exclusion">
                                <ChooseExclusion onChange={this.handleExclusionChange}/>
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-1">
                        <div className="floating-label job-divider">
                            <Divider>or</Divider>
                        </div>
                    </div>
                    <div className="col-sm-7 col-12">
                        <div className="floating-label">
                            <FormItem label="Enter Custom Exclusion">
                                {getFieldDecorator('exclusion', {
                                })(<TextArea className="job-desc-field" autosize={{minRows: 1, maxRows: 8}}
                                             placeholder="Enter Here"/>)}
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-4 col-12">
                        <div className="floating-label">
                            <FormItem label="Choose Notes">
                                <ChooseNotes onChange={this.handleNotesChange}/>
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-1">
                        <div className="floating-label job-divider">
                            <Divider>or</Divider>
                        </div>
                    </div>
                    <div className="col-sm-7 col-12">
                        <div className="floating-label">
                            <FormItem label="Enter Custom Notes">
                                {getFieldDecorator('notes', {
                                })(<TextArea className="job-desc-field" autosize={{minRows: 1, maxRows: 8}}
                                             placeholder="Enter Here"/>)}
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-4 col-12">
                        <div className="floating-label">
                            <FormItem label="Choose Payment Terms & Conditions">
                                <ChoosePaymentTerm onChange={this.handlePaymentChange}/>
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-1">
                        <div className="floating-label job-divider">
                            <Divider>or</Divider>
                        </div>
                    </div>
                    <div className="col-sm-7 col-12">
                        <div className="floating-label">
                            <FormItem label="Enter Custom Notes">
                                {getFieldDecorator('payment_term', {
                                })(<TextArea className="job-desc-field" autosize={{minRows: 1, maxRows: 8}}
                                             placeholder="Enter Here"/>)}
                            </FormItem>
                        </div>
                    </div>
                </div>
                <div className="row step-footer ">
                    <div className="col-12 steps-action text-right">
                        <Button className="nxtPrev-btn" loading={loading} type="primary"
                                onClick={this.submitProposalSettingForm}>Submit</Button>
                        <Button className="back-btn" onClick={this.props.onBack}>Previous</Button>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export const AddSettings = Form.create()(AddSettingsForm);



// WEBPACK FOOTER //
// ./src/pages/crm/proposals/popups/add_proposal_steps/AddSettings.jsx